import React from 'react'
import styled from 'styled-components'

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
`

const ToggleLabel = styled.label`
  display: flex;
  align-items: center;
`

const ToggleStyledInput = styled.input`
  appearance: none;
  width: 34px;
  height: 14px;
  border-radius: 14px;
  background-color: #999999;
  position: relative;
  outline: none;
  cursor: pointer;

  &::before {
    content: "";
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.20);
    position: absolute;
    top: -3px;
    left: -3px;
    transition: 0.2s ease 0s;
  }
  &:checked {
    background-color: #B0E3F0;
    &::before {
      left: 17px;
      opacity: 1;
      background-color: #028BB7;
    }
  }
`

const ToggleInput = (props) => {
  return (
    <ToggleContainer>
      <ToggleLabel>
        <ToggleStyledInput
          type="checkbox"
          {...props}
        />
      </ToggleLabel>
    </ToggleContainer>
  )
}

export default ToggleInput
